<template>
  <Modal :title="modalTitle" :error="error" body-overflow="auto" @close="$emit('close')">
    <div v-if="loading" class="muted">Loading…</div>
    <div v-else-if="!event" class="muted">Event not found.</div>
    <div v-else class="detailBody">
      <div class="emailHeader">
        <div><span class="muted">Subject</span> <span class="emailValue">{{ event.subject || '—' }}</span></div>
        <div style="margin-top:6px;"><span class="muted">With</span> <span class="emailValue">{{ event.who_name || event.who_email || '—' }}</span></div>
        <div style="margin-top:6px;"><span class="muted">Owner</span> <span class="emailValue">{{ event.owner_name || event.owner_email || '—' }}</span></div>
        <div style="margin-top:6px;"><span class="muted">Related</span> <span class="emailValue">{{ event.what_name || event.related_account_name || '—' }}</span></div>
        <div style="margin-top:6px;" class="muted">
          {{ formatDate(event.start_datetime || event.activity_date) }}
          <span v-if="event.end_datetime"> → {{ formatDate(event.end_datetime) }}</span>
        </div>
      </div>
      <div class="emailBody">{{ event.description || '' }}</div>
    </div>
  </Modal>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import Modal from './Modal.vue'
import { apiFetch } from '../services/api.ts'

const props = defineProps({
  accountId: { type: [String, Number], required: true },
  eventId: { type: [String, Number], required: true },
  initialEvent: { type: Object, default: null },
})

defineEmits(['close'])

const loading = ref(false)
const error = ref('')
const event = ref(props.initialEvent || null)

const modalTitle = computed(() => String(event.value?.subject || 'Event'))

function formatDate(value) {
  if (!value) return '—'
  try {
    return new Date(value).toLocaleString()
  } catch {
    return String(value)
  }
}

async function loadEvent() {
  const accountId = String(props.accountId || '').trim()
  const eventId = String(props.eventId || '').trim()
  if (!accountId || !eventId) return
  if (props.initialEvent && String(props.initialEvent?.id || '').trim() === eventId) {
    event.value = props.initialEvent
    return
  }
  loading.value = true
  error.value = ''
  try {
    const resp = await apiFetch(`/accounts/${encodeURIComponent(accountId)}/salesforce_events/${encodeURIComponent(eventId)}`)
    event.value = resp?.event || null
  } catch (e) {
    error.value = e?.message || 'Failed to load event'
    event.value = null
  } finally {
    loading.value = false
  }
}

watch(() => [props.accountId, props.eventId], () => {
  void loadEvent()
}, { immediate: true })
</script>
